import PropTypes from "prop-types";
import React from "react";

import onPulseAnimationEnd from "../onPulseAnimationEnd";

const ToolbarTextLabel = props => (
  <div
    id={props.id ? props.id : null}
    className={`toolbarTextBtn ${props.active ? "active" : ""}  ${props.pulse ? "pulse" : ""}`}
    onClick={props.onClick ? props.onClick : null}
    onAnimationEnd={onPulseAnimationEnd}
  >
    <span>{props.text}</span>
  </div>
);

ToolbarTextLabel.propTypes = {
  text: PropTypes.string.isRequired,
  active: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  pulse: PropTypes.bool
};

export default ToolbarTextLabel;
